import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "./dev";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <DevSupport ComponentPreviews={ComponentPreviews}
        useInitialHook={useInitial}
    >
        <App />
    </DevSupport>
);

// Service Worker Registration for PWA and caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Use the correct path based on homepage configuration
    const swPath = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/sw.js` : '/sw.js';
    navigator.serviceWorker.register(swPath)
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available
              console.log('New version available');
            }
          });
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Performance monitoring and optimization
const performanceObserver = new PerformanceObserver((list) => {
  for (const entry of list.getEntries()) {
    if (entry.entryType === 'navigation') {
      console.log('Page load time:', entry.loadEventEnd - entry.loadEventStart, 'ms');
    }
    
    if (entry.entryType === 'resource') {
      if (entry.duration > 1000) { // Log slow resources
        console.warn('Slow resource detected:', entry.name, entry.duration, 'ms');
      }
    }
  }
});

performanceObserver.observe({ entryTypes: ['navigation', 'resource'] });

// Memory usage monitoring
if ('memory' in performance) {
  setInterval(() => {
    const memory = performance.memory;
    if (memory.usedJSHeapSize > memory.jsHeapSizeLimit * 0.8) {
      console.warn('High memory usage detected:', 
        Math.round(memory.usedJSHeapSize / 1024 / 1024), 'MB');
    }
  }, 30000); // Check every 30 seconds
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
